import Vue from 'vue';
import Vuex from 'vuex';
import typesData from './typesData';
import themesData from './themesData';
import blocksData from './blocksData';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        typesData,
        themesData,
        blocksData,
    }
});
